// NPM imports
import React from "react";
import PropTypes from "prop-types";

function Label(props) {
  const { htmlFor, children, ...otherProps } = props;

  return (
    <label data-test="label" htmlFor={htmlFor} {...otherProps}>
      <input data-test="label-input" type="hidden" />
      {children}
    </label>
  );
}

Label.defaultProps = {
  children: "",
};

Label.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default Label;
